// Draws the creatures into every <div class="creature" data-kind="...">.
// Each limb is a nested group that rotates around its own joint, so arms and
// legs bend at the elbow/knee. Timing is randomized per creature so no two
// move in step.

(function () {
  const rand = (a, b) => (a + Math.random() * (b - a)).toFixed(2);

  // a limb that rotates around (ox, oy); children rotate with it
  const L = (ox, oy, amp, inner) =>
    `<g class="limb" style="--o:${ox}px ${oy}px;--a:${amp}deg;--t:${rand(5, 12)}s;--dl:-${rand(0, 12)}s">${inner}</g>`;
  const seg = (x1, y1, x2, y2, w) => `<path d="M${x1} ${y1} L${x2} ${y2}" stroke-width="${w}"/>`;
  const fingers = (x, y, dir = 1) =>
    L(x, y, 12,
      [[-8, 20], [-3, 25], [3, 25], [8, 19]]
        .map(([dx, dy]) => seg(x, y, x + dx, y + dy * dir, 1.3))
        .join(""));
  const eyes = (pts) => `<g class="eyes">${pts.map(([x, y]) => `<circle cx="${x}" cy="${y}" r="1.2"/>`).join("")}</g>`;

  // spider-legged thing standing high on six jointed legs
  function crawler() {
    const legs = [
      [88, 92, 40, 50, 20, 296], [92, 98, 55, 38, 58, 296], [96, 102, 74, 60, 88, 296],
      [112, 92, 160, 50, 180, 296], [108, 98, 145, 38, 142, 296], [104, 102, 126, 60, 112, 296],
    ];
    return (
      legs.map(([hx, hy, kx, ky, fx, fy]) => L(hx, hy, 3, seg(hx, hy, kx, ky, 4) + L(kx, ky, 4, seg(kx, ky, fx, fy, 2.2)))).join("") +
      `<ellipse cx="100" cy="94" rx="24" ry="14" fill="#000"/>` +
      `<ellipse cx="100" cy="112" rx="13" ry="19" fill="#000"/>` +
      L(100, 84, 6,
        `<path fill="#000" d="M90 84 L85 58 L94 72 L100 66 L106 72 L115 58 L110 84 Z"/>` +
        eyes([[95, 77], [105, 77], [98, 72], [102, 72]]))
    );
  }

  // tall thin thing, head hanging forward on a long neck, backward knees, one arm with an extra joint
  function stilt() {
    return (
      `<path d="M100 195 Q96 140 102 95" stroke-width="9"/>` +
      `<path d="M84 100 Q100 92 118 100" stroke-width="6"/>` +
      L(102, 95, 8,
        `<path d="M102 95 Q112 70 128 66" stroke-width="5"/>` +
        `<ellipse cx="136" cy="72" rx="16" ry="7" transform="rotate(25 136 72)" fill="#000"/>` +
        eyes([[138, 74], [144, 77]])) +
      L(84, 100, 4, seg(84, 100, 66, 175, 4) + L(66, 175, 6, seg(66, 175, 78, 250, 3) + fingers(78, 250))) +
      L(118, 100, 4, seg(118, 100, 134, 150, 4) + L(134, 150, 6, seg(134, 150, 150, 205, 3) + L(150, 205, 8, seg(150, 205, 138, 258, 2.6) + fingers(138, 258)))) +
      L(98, 195, 2, seg(98, 195, 78, 240, 5) + L(78, 240, 3, seg(78, 240, 96, 272, 3.5) + seg(96, 272, 86, 298, 2.5))) +
      L(104, 195, 2, seg(104, 195, 124, 238, 5) + L(124, 238, 3, seg(124, 238, 112, 270, 3.5) + seg(112, 270, 124, 298, 2.5)))
    );
  }

  // robed thing with antlers and six arms that never stop moving
  function crowned() {
    const arms = [
      [95, 48, 20, 24, 70], [125, 44, 28, 30, 90], [155, 52, 30, 40, 100],
    ];
    let a = "";
    for (const [y, ex, ey, wx, wy] of arms) {
      a += L(80, y, 10, seg(80, y, ex, y + ey, 3) + L(ex, y + ey, 12, seg(ex, y + ey, wx, y + wy, 2) + fingers(wx, y + wy)));
      const rx = 200 - ex, rwx = 200 - wx;
      a += L(120, y, 10, seg(120, y, rx, y + ey, 3) + L(rx, y + ey, 12, seg(rx, y + ey, rwx, y + wy, 2) + fingers(rwx, y + wy)));
    }
    return (
      a +
      `<path fill="#000" d="M100 70 C84 72 76 92 78 120 C80 170 70 230 60 300 L140 300 C130 230 120 170 122 120 C124 92 116 72 100 70 Z"/>` +
      L(100, 66, 3,
        `<circle cx="100" cy="62" r="11" fill="#000"/>` +
        `<g stroke-width="2.5"><path d="M96 54 Q80 30 70 8"/><path d="M84 34 Q70 30 62 22"/><path d="M78 22 Q86 12 84 2"/>` +
        `<path d="M104 54 Q120 30 130 8"/><path d="M116 34 Q130 30 138 22"/><path d="M122 22 Q114 12 116 2"/></g>` +
        eyes([[95, 62], [105, 62], [100, 56]]))
    );
  }

  // hangs upside down from the top edge and slowly swings
  function hanger() {
    return L(100, 0, 2,
      `<path d="M70 0 L86 30 L94 62" stroke-width="4"/><path d="M130 0 L114 30 L106 62" stroke-width="4"/>` +
      `<path fill="#000" d="M92 60 C86 90 88 120 94 140 L106 140 C112 120 114 90 108 60 Z"/>` +
      L(100, 140, 5,
        `<ellipse cx="100" cy="156" rx="10" ry="13" fill="#000"/>` +
        `<path fill="#000" d="M93 166 L90 186 L97 168 Z"/><path fill="#000" d="M107 166 L110 186 L103 168 Z"/>` +
        eyes([[96, 160], [104, 160]])) +
      L(92, 132, 6, seg(92, 132, 74, 200, 3) + L(74, 200, 9, seg(74, 200, 80, 272, 2.4) + fingers(80, 272))) +
      L(108, 132, 6, seg(108, 132, 126, 200, 3) + L(126, 200, 9, seg(126, 200, 120, 272, 2.4) + fingers(120, 272)))
    );
  }

  const kinds = { crawler, stilt, crowned, hanger };

  document.querySelectorAll(".creature[data-kind]").forEach((el) => {
    const draw = kinds[el.dataset.kind];
    if (!draw) return;
    el.innerHTML =
      `<svg viewBox="0 0 200 300" preserveAspectRatio="${el.dataset.kind === "hanger" ? "xMidYMin" : "xMidYMax"} meet" aria-hidden="true">` +
      `<g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round">${draw()}</g></svg>`;
  });
})();
